<style scoped>
.fa {
  margin-right: 10px;
}
</style>
<template>
  <div class="page-header-menu">
    <div class="container-fluid">
      <div class="hor-menu">
        <ul class="nav navbar-nav" v-if="this.isAuthenticated">
          <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
            <a href="javascript:;">
              Stakeholder Requests
              <span class="arrow"></span>
            </a>
            <ul class="dropdown-menu pull-left">
              <li>
                <router-link to="/enhancement/add">
                  <i class="fa fa-plus-square"></i> Add New
                </router-link>
              </li>
              <li>
                <router-link to="/enhancement/status">
                  <i class="fa fa-question-circle"></i> Request Status
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "PageMenu",
  props: ["isAuthenticated"]
};
</script>
